'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactChartjs = require('react-chartjs-2');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDataEmpty(data) {
  // Check that there are exactly zero values in dataset
  return data.filter(function (datum) {
    return datum.y;
  }).length === 0;
}

function getXAxisData(data, timezoneOffset) {
  return {
    type: 'time',
    position: 'bottom',
    time: {
      tooltipFormat: 'h:mm:ss a',
      unit: 'day',
      min: data ? data[data.length - 1].x : 0,
      max: data ? data[0].x : 0,
      unitStepSize: 1,
      minUnit: 'day',
      displayFormats: {
        day: 'MMM Do'
      },
      parser: function parser(date) {
        var momentDate = (0, _moment2.default)(date);
        if (timezoneOffset !== undefined) {
          return momentDate.utcOffset(timezoneOffset);
        }
        return momentDate;
      }
    },
    ticks: {
      fixedStepSize: 1
    },
    gridLines: {
      zeroLineColor: 'rgba(0, 0, 0, 0.1)'
    },
    afterBuildTicks: function afterBuildTicks(chart) {
      // Removes first tick line, and rounds last tick line
      // to the beginning of the day
      chart.ticks.push(chart.ticks.pop().startOf('day'));
      chart.ticks.shift();
    }
  };
}

function getDataset(data, label, isSecond) {
  return {
    backgroundColor: isSecond ? 'rgba(151,0,205,0.2)' : 'rgba(151,187,205,0.2)',
    borderColor: isSecond ? 'rgba(151,0,205,1)' : 'rgba(151,187,205,1)',
    pointBackgroundColor: isSecond ? 'rgba(151,0,205,1)' : 'rgba(151,187,205,1)',
    // pointBorderColor: '#fff',
    pointHoverBorderColor: '#fff',
    pointHoverBackgroundColor: 'yellow',
    pointHoverBorderWidth: 2,
    fill: false,
    label: label,
    data: data,
    yAxisID: isSecond ? 'second-y-axis' : 'first-y-axis'
  };
}

// eslint-disable-next-line react/prefer-stateless-function
var CameraChart = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CameraChart, _Component);

  function CameraChart() {
    (0, _classCallCheck3.default)(this, CameraChart);
    return (0, _possibleConstructorReturn3.default)(this, (CameraChart.__proto__ || (0, _getPrototypeOf2.default)(CameraChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(CameraChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          data2 = _props.data2,
          label = _props.label,
          label2 = _props.label2,
          hideLines = _props.hideLines,
          bigPoints = _props.bigPoints,
          timezoneOffset = _props.timezoneOffset;


      var chartOptions = {
        responsive: true,
        animation: false,
        scales: {
          yAxes: [{
            id: 'first-y-axis',
            type: 'linear',
            drawOnChartArea: true,
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5
            }
          }]
        },
        maintainAspectRatio: false,
        padding: {
          left: -50
        },
        legend: {
          display: false
        },
        showLines: !hideLines
      };

      var xAxisData = [];
      var datasets = [];
      // console.log(`data: ${data}`);

      if (isDataEmpty(data)) {
        return _react2.default.createElement(
          'div',
          null,
          'No data found.'
        );
      }

      if (data) {
        xAxisData = xAxisData.concat(getXAxisData(data, timezoneOffset));
        datasets = datasets.concat(getDataset(data, label));
      }

      if (data2 && !isDataEmpty(data2)) {
        // xAxisData = xAxisData.concat(getXAxisData(data2, timezoneOffset));
        datasets = datasets.concat(getDataset(data2, label2, true));

        chartOptions.scales.yAxes.push({
          id: 'second-y-axis',
          type: 'linear',
          drawOnChartArea: true,
          position: 'right',
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5
          }
        });
      }

      // Set x axis data
      chartOptions.scales.xAxes = xAxisData;

      var chartData = {
        datasets: datasets
      };
      var chartContainerStyle = {
        'margin-left': '-17px',
        'margin-top': '5px'
      };

      if (bigPoints) {
        chartData.datasets[0].pointRadius = 5;
        chartData.datasets[0].pointHoverRadius = 7;
      }

      return _react2.default.createElement(
        'div',
        { style: chartContainerStyle },
        _react2.default.createElement(_reactChartjs.Line, { data: chartData, options: chartOptions, height: 250 })
      );
    }
  }]);
  return CameraChart;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array,
  label: _react.PropTypes.string,
  hideLines: _react.PropTypes.bool,
  bigPoints: _react.PropTypes.bool,
  data2: _react.PropTypes.array,
  label2: _react.PropTypes.string,
  timezoneOffset: _react.PropTypes.number
}, _temp);
exports.default = CameraChart;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CameraChart/CameraChart.js
 ** module id = 1378
 ** module chunks = 0
 **/